"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EBalanceWithdrawModalWindowType = exports.ETabTypes = exports.EPaymentModalTypes = void 0;
var EPaymentModalTypes;
(function (EPaymentModalTypes) {
    EPaymentModalTypes["Success"] = "success";
    EPaymentModalTypes["Canceled"] = "canceled";
})(EPaymentModalTypes || (exports.EPaymentModalTypes = EPaymentModalTypes = {}));
var ETabTypes;
(function (ETabTypes) {
    ETabTypes["Payment"] = "payment";
    ETabTypes["Withdraw"] = "withdraw";
    ETabTypes["History"] = "history";
    ETabTypes["Bonus"] = "bonus";
})(ETabTypes || (exports.ETabTypes = ETabTypes = {}));
var EBalanceWithdrawModalWindowType;
(function (EBalanceWithdrawModalWindowType) {
    EBalanceWithdrawModalWindowType[EBalanceWithdrawModalWindowType["OFF"] = 0] = "OFF";
    EBalanceWithdrawModalWindowType[EBalanceWithdrawModalWindowType["SUCCESS"] = 1] = "SUCCESS";
    EBalanceWithdrawModalWindowType[EBalanceWithdrawModalWindowType["SMS"] = 2] = "SMS";
    EBalanceWithdrawModalWindowType[EBalanceWithdrawModalWindowType["ERROR"] = 3] = "ERROR";
})(EBalanceWithdrawModalWindowType || (exports.EBalanceWithdrawModalWindowType = EBalanceWithdrawModalWindowType = {}));
//# sourceMappingURL=types.js.map